import { memo } from 'react';
import InventoryIcon from '@mui/icons-material/Inventory';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@dfl/mui-react-common';
import { useToggle } from '@dfl/hook-utils';
import { useProductDetail } from 'modules/inventory/product/contexts/ProductDetail';
import { STOCK_ACTIVITY_OPERATIONS } from 'modules/inventory/product/constants/stock-operations.constants';
import AvailableProductEditModal from 'modules/inventory/product-stock/containers/AvailableProductEditModal';
import { IProductStockItem } from '../../interfaces/IStockResponse';
import { isComboProduct } from 'modules/inventory/product/utils/is-combo-product';

type UserStatusProps = {
  record: IProductStockItem;
};

const ProductInventoryStoreUpdateButton = ({ record }: UserStatusProps) => {
  const { t } = useTranslation('product');
  const { isOpen, onOpen, onClose } = useToggle();
  const { product } = useProductDetail();

  // Misma puerta que la del formulario de la cabecera: el stock de un combo es
  // virtual (reservas de sus componentes) y el backend rechaza escribirlo por
  // esta vía con COMBO_STOCK_NOT_DIRECTLY_MANAGEABLE. Se arma desde la sección
  // Combo de la pestaña General, no fila a fila. El aviso que lo explica lo
  // pinta ProductInventoryListToolbar una sola vez, arriba de la tabla.
  if (isComboProduct(product)) return null;

  return (
    <>
      <LoadingButton variant='outlined' startIcon={<InventoryIcon />} onClick={onOpen}>
        {t('section.inventory.update')}
      </LoadingButton>
      <AvailableProductEditModal
        open={isOpen}
        onClose={onClose}
        initValue={{
          warehouse: record?.warehouse,
          responsible: record?.responsible || '',
          warehouseArea: record?.warehouseArea?.areaId,
          quantity: 0,
          providerType: undefined,
          evidence: [],
          operation: STOCK_ACTIVITY_OPERATIONS.ADDED,
          cause: undefined,
        }}
        productId={product?._id as string}
        stock={record?.available}
      />
    </>
  );
};

export default memo(ProductInventoryStoreUpdateButton);
